export function getReceivableShipmentItems(shipment) {
  return (shipment?.shipmentItems || []).filter(
    shipmentItem => shipmentItem.asset?.id && Number(shipmentItem.quantity) > 0
  );
}

export function mergeAppliedShipmentItems(existingSnapshot = [], nextSnapshot = []) {
  const byId = new Map(
    existingSnapshot.map(entry => [String(entry.shipmentItemId), { ...entry }])
  );

  nextSnapshot.forEach(entry => {
    const key = String(entry.shipmentItemId);
    const previous = byId.get(key);
    byId.set(key, {
      ...entry,
      quantity: previous
        ? Number(previous.quantity) + Number(entry.quantity)
        : Number(entry.quantity),
    });
  });

  return Array.from(byId.values());
}

export function getReservationItemSync(receivedItems, appliedSnapshot = []) {
  const snapshotById = new Map(
    appliedSnapshot.map(entry => [String(entry.shipmentItemId), entry])
  );

  const pending = [];
  const added = [];

  receivedItems.forEach(shipmentItem => {
    const snapshot = snapshotById.get(String(shipmentItem.id));
    const currentQuantity = Number(shipmentItem.quantity);
    const appliedQuantity = snapshot ? Number(snapshot.quantity) : 0;

    if (!snapshot || currentQuantity > appliedQuantity) {
      pending.push({
        shipmentItem,
        quantityToAdd: currentQuantity - appliedQuantity,
      });
    } else {
      added.push(shipmentItem);
    }
  });

  return {
    added,
    pending,
    allSynced: pending.length === 0 && receivedItems.length > 0,
    hasReceivableItems: receivedItems.length > 0,
  };
}

export function getShipmentItemLabel(shipmentItem) {
  const { asset } = shipmentItem;
  const title = [asset?.itemId, asset?.itemCode, asset?.barcode, asset?.skuNumber]
    .filter(Boolean)
    .join(" | ");

  return title || asset?.description || "Item";
}
